import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
import { CalenderEvent } from '../../_models/communications/event/calender-event';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private url: string = environment.apiUrl;
  constructor(private http: HttpClient) { }


  getEvents(startDate: string, endDate: string) {
    return this.http.get(`${this.url}Event/GetAllEvent/${startDate}/${endDate}`);
  }
  getEventById(id: number) {
    return this.http.get(`${this.url}Event/GetEvent/${id}`);
  }
  CreatEvent(data) {
    return this.http.post(`${this.url}Event/CreateEvent`, data);
  }
  UpdateEvent(data) {
    return this.http.put(`${this.url}Event/UpdateEvent`, data);
  }
  DeleteEvent(id: number) {
    return this.http.delete(`${this.url}Event/DeleteEvent/${id}`);
  }
  GetEventCount() {
    return this.http.get(`${this.url}Event/GetEventCount/`);
  }
  getMostUsedColors() {
    return ['#76AA6D', '#B94A48', '#FF8357'];
  }
}
